import { ErrorCard } from '@starsoft/common/components';
import LuckySpinLabels from './Labels';
import LuckySpinRouletteLight from './Light';
import LuckySkeleton from './LuckySkeleton';

import Head from 'next/head';
import { generateLuckySpinPreload } from './preloads';

import useLuckySpinState from '@/hooks/lucky-spin/useLuckySpinState';
import { Image } from '@starsoft/common/components';
import styles from './styles.module.scss';

export default function LuckySpinRoulette() {
  const {
    useLuckySpinsRewardsByLuckySpinQuery: {
      error,
      refetch,
      isLoading,
      prizeIndex,
    },
    mode,
    rankName,
    handleStopSpinning,
    isSpinning,
  } = useLuckySpinState();

  const Preloads = generateLuckySpinPreload();

  if (isLoading) {
    return (
      <div className={styles.container}>
        <LuckySkeleton />
      </div>
    );
  }

  if (error) {
    return <ErrorCard error={error} refetch={refetch} />;
  }

  return (
    <div className={styles.container__wrapper}>
      <Head>{Preloads}</Head>
      <div className={styles.container} key={`container-mode-${mode}`}>
        <Image
          format="square"
          width={348}
          height={348}
          onAnimationEnd={handleStopSpinning}
          src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/lucky-spin/${rankName}/png/ice-spin-${rankName.toLowerCase()}.png`}
          secondarySkeleton
          className={`${styles.container__roulette} ${isSpinning ? styles['container__roulette--spinning'] : ''}`}
          alt="lucky-spin-roulette"
          style={{
            //@ts-ignore
            '--prize-index': Number(prizeIndex),
          }}
          preload
        />
        <LuckySpinRouletteLight
          isSpinning={isSpinning}
          prizeIndex={Number(prizeIndex)}
          mode={mode}
        />
        <Image
          format="square"
          width={160}
          preload
          height={160}
          alt="roulette indicator"
          className={`${styles.container__indicator} ${process.env.NEXT_PUBLIC_TENANT_ID === 'kube' ? styles['container__indicator--kube'] : ''}`}
          src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/lucky-spin/${rankName}/png/ice-point-${rankName.toLowerCase()}.png`}
          secondarySkeleton
        />
        <LuckySpinLabels isSpinning={isSpinning} mode={mode} />
      </div>
      <Image
        alt="roulette button"
        format="square"
        width={104}
        className={styles.container__button}
        height={104}
        src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/lucky-spin/${rankName}/png/ice-spin-center-${rankName.toLowerCase()}.png`}
        secondarySkeleton
      />
    </div>
  );
}
